<mat-form-field appearance="outline" *ngIf="view === 'data' || view === 'fill'">
    <mat-label>{{ field?.label }}</mat-label>
    <input matInput
        id=""
        type="number"
        [ngModel]="value"
        (ngModelChange)="updateValue($event)"
        [min]="minValue"
        [max]="maxValue"
        [required]="required"
        [readonly]="view === 'data'"
    />
    <mat-error *ngIf="error">{{error}}</mat-error>
</mat-form-field>

<div class="edit" *ngIf="view === 'edit'">

    <mat-checkbox
        [ngModel]="required"
        (ngModelChange)="updateRequired($event)"
    >Requis</mat-checkbox>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Minimum</mat-label>
        <input matInput
            id=""
            type="number"
            [ngModel]="minValue"
            (ngModelChange)="updateMinValue($event)"
        />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Maximum</mat-label>
        <input matInput
            id=""
            type="number"
            [ngModel]="maxValue"
            (ngModelChange)="updateMaxValue($event)"
        />
    </mat-form-field>

</div>
